<template>
	<div class="form-box">
		<div style="margin-top:12px;">
			<a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" class="product-tab">
				<a-row>
					<a-col :span="24">
						<a-form-item label="产品分类" required>
							<a-radio-group name="radioGroup" :disabled="initialData.lang === 'EN'" v-decorator="['businessType', { rules: [{ required: true, message: '请选择产品分类' }] }]">
								<a-radio value="CAT"> 猫 </a-radio>
								<a-radio value="DOG"> 狗 </a-radio>
							</a-radio-group>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="产品名称" required>
							<a-input placeholder="请输入产品名称" style="width: 100%;" v-decorator="['productName', { rules: [{ required: true, message: '请输入产品名称' }] }]" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="列表标签" v-if="ifFacOrBr=='2'" required>
							<div v-decorator="['tagList', { rules: [{ required: true, message: '请添加列表标签' }] }]" style="display: none;"></div>
							<div style="display:flex;">
								<a-input v-model="tagInput" placeholder="请输入列表标签" :disabled="tagListItems.length >= 3" />
								<a-button style="width:100px;margin-left:20px" type="primary" @click="addTag" :disabled="tagListItems.length >= 3">+ 新增</a-button>
							</div>
							<div ref="dragTagList" style="width:100%;margin-top:8px">
								<div class="size_item" v-for="(item,idx) of tagListItems" :key="item">
									<span class="left">{{ item }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delTag(idx)" />
								</div>
							</div>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="链接地址">
						<div style="display: flex; gap: 12px;">
							<a-input placeholder="显示文案" v-model="editModel.urlName" style="width: 50%;" />
							<a-input placeholder="请输入链接地址" v-model="editModel.url" style="width: 50%;" />
						</div>
					</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="上传缩略图" required>
							<div v-decorator="['productThumbnail', { rules: [{ required: true, message: '请上传缩略图' }] }]" style="display: none;"></div>
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.productThumbnail">
									<viewer :images="[editModel.productThumbnail]">
										<div class="er_content">
											<img class="er_content_img" :src="img"
												v-for="(img,index) in [editModel.productThumbnail]" :key="index">
										</div>
									</viewer>
								</div>
								<div class="again_upload_box ml12">
									<a-spin :spinning="uploadThumbnailLoading" size="small">
									<input type="file" accept="image/*" @change="uploadThumbnail" :disabled="uploadThumbnailLoading" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">
										{{ editModel.productThumbnail ? "重新上传缩略图" : "上传缩略图" }}
									</div>
									</a-spin>
								</div>
							</div>
							<div>只能上传jpg/png格式文件，文件不能超过3M</div>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="上传主图" required>
							<div v-decorator="['productImages', { rules: [{ required: true, message: '请至少上传一张主图' }] }]" style="display: none;"></div>
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.productImagesList && editModel.productImagesList.length > 0">
									<div class="er_content" ref="dragMainImages">
										<div class="image-wrapper"
											 v-for="(img,index) in editModel.productImagesList" :key="img"
											 style="position: relative;display: inline-block;margin: 5px;cursor: grab;">
											<viewer :images="editModel.productImagesList">
												<img class="er_content_img" :src="img" style="display: block;width:80px;height:80px;object-fit:cover;">
											</viewer>
											<a-icon type="close-circle" style="position: absolute; top: -8px; right: -8px; font-size: 18px; color: #f5222d; cursor: pointer; z-index: 10;" @click="handleDeleteMainImg(index)" />
										</div>
									</div>
								</div>
								<div class="again_upload_box ml12" v-if="(editModel.productImagesList || []).length < 10">
									<a-spin :spinning="uploadMainImageLoading" size="small">
										<input type="file" accept="image/*" multiple @change="uploadMainImage" :disabled="uploadMainImageLoading" />
										<i class="el-icon-box again_upload_icon"></i>
										<div class="bold" style="width: 100px">上传产品主图</div>
									</a-spin>
								</div>
							</div>
							<div>只能上传jpg/png格式文件，文件不能超过3M，不能超过10张</div>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="视频封面">
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.videoImage">
									<viewer :images="[editModel.videoImage]">
										<div class="er_content">
											<img class="er_content_img" :src="img"
												 v-for="(img,index) in [editModel.videoImage]" :key="index">
										</div>
									</viewer>
								</div>
								<div class="again_upload_box ml12">
									<a-spin :spinning="uploadVideoCoverLoading" size="small">
										<input type="file" accept="image/*" @change="uploadVideoCover" :disabled="uploadVideoCoverLoading" />
										<i class="el-icon-box again_upload_icon"></i>
										<div class="bold" style="width: 100px">{{ editModel.videoImage ? "重新上传封面" : "上传封面" }}</div>
									</a-spin>
								</div>
							</div>
							<div>只能上传jpg/png格式文件，文件不能超过3M</div>

						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="上传视频">
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.videoUrl">
									<video :src="editModel.videoUrl"
										   style="width: 80px; height: 80px; object-fit: cover;" controls></video>
								</div>
								<div class="again_upload_box ml12">
									<a-spin :spinning="uploadVideoFileLoading" size="small">
										<input type="file" accept="video/*" @change="uploadVideoFile" :disabled="uploadVideoFileLoading" />
										<i class="el-icon-box again_upload_icon"></i>
										<div class="bold" style="width: 100px">{{ editModel.videoUrl ? "重新上传视频" : "上传视频" }}</div>
									</a-spin>
								</div>
							</div>
							<div>只能上传mp4格式文件，文件不能超过10M</div>

						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="价格" required>
							<div style="display: flex; align-items: flex-start; gap: 8px; flex-wrap: wrap;">
							<a-form-item style="margin-bottom:0;width:120px;" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" :colon="false">
								<a-input style="width:120px;" v-decorator="['minPrice', { rules: [{ required: true, message: ifFacOrBr === '2' ? '请输入价格' : '请输入最低价格' }] }]" :placeholder="ifFacOrBr=='2' ? '请输入价格' : '最低价格'" />
							</a-form-item>
							<span v-if="ifFacOrBr=='1'">~</span>
							<a-form-item v-if="ifFacOrBr!='2'" style="margin-bottom:0;width:120px;" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" :colon="false">
								<a-input placeholder="最高价格" style="width:120px;" v-decorator="['maxPrice', { rules: [{ required: true, message: '请输入最高价格' }] }]" />
							</a-form-item>
							<span v-if="ifFacOrBr=='1'">元/</span><span v-else>元</span>
							<a-form-item v-if="ifFacOrBr!='2'" style="margin-bottom:0;width:100px;" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" :colon="false">
								<a-input placeholder="单位" style="width:100px;" v-decorator="['productUnit', { rules: [{ required: true, message: '请输入单位' }] }]" />
							</a-form-item>
							<a-input v-if="ifFacOrBr=='2'" placeholder="请输入渠道(非必填)" v-model="editModel.priceChannel" style="flex: 1; min-width: 100px;" />
							</div>
						</a-form-item>
						<a-form-item label="规格 SKU" required v-if="ifFacOrBr=='2'">
						<div style="display:flex;align-items:flex-start;gap:12px;">
							<a-input placeholder="请输入规格 SKU" style="flex:1;" v-decorator="['sku', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请输入规格 SKU' }] : [] }]" />
							<div style="width:100px;">
								<a-form-item style="margin-bottom:0;" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" :colon="false">
									<a-input placeholder="请输入单位" v-decorator="['productUnit', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请输入单位' }] : [] }]" />
								</a-form-item>
							</div>
						</div>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="品类" required>
							<div v-decorator="['tagId', { rules: [{ required: true, message: '请选择品类' }] }]" style="display: none;"></div>
							<a-select placeholder="请选择品类" show-search option-filter-prop="name" :filter-option="filterOption" v-model="editModel.tagId" :disabled="initialData.lang === 'EN'">
								<a-select-option v-for="item of allTags" :key="item.tagId" :value="item.tagId">{{ item.tagName }}</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="核心功效" required v-if="ifFacOrBr=='2'">
							<a-input placeholder="请输入核心功效" style="width: 100%;" v-decorator="['keyCapabilities', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请输入核心功效' }] : [] }]" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="适用阶段" required v-if="ifFacOrBr=='2'">
							<a-select placeholder="请选择适用阶段" v-decorator="['stages', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请选择适用阶段' }] : [] }]" :disabled="initialData.lang === 'EN'">
								<a-select-option value="AS">全阶段</a-select-option>
								<a-select-option value="SR">老年期</a-select-option>
								<a-select-option value="JUV">幼年期</a-select-option>
								<a-select-option value="WN">离乳期</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="品名" required v-if="ifFacOrBr=='2'">
							<a-input placeholder="请输入品名" style="width: 100%;" v-decorator="['productAb', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请输入品名' }] : [] }]" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="口味" required v-if="ifFacOrBr=='2'">
							<a-input placeholder="请输入口味" style="width: 100%;" v-decorator="['taste', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请输入口味' }] : [] }]" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="生产许可" v-if="ifFacOrBr=='2'">
							<a-input placeholder="请输入生产许可" style="width: 100%;" v-decorator="['productionLicense', { rules: [{ required: true, message: '请输入生产许可' }] }]" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="特色原料" v-if="ifFacOrBr=='2'">
							<a-textarea :rows="2" placeholder="请输入特色原料" style="width: 100%;" v-decorator="['signatureIngredients']" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="生产厂家" required v-if="ifFacOrBr=='2'">
						<a-select placeholder="请选择生产厂家" show-search option-filter-prop="name" :filter-option="filterOption" v-decorator="['factoryId', { rules: ifFacOrBr === '2' ? [{ required: true, message: '请选择生产厂家' }] : [] }]" :disabled="initialData.lang === 'EN'">
							<a-select-option v-for="item of factoryList" :key="item.businessId" :value="item.businessId" :name="item.businessName">{{ item.businessName }}</a-select-option>
						</a-select>
					</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="代理政策" v-if="ifFacOrBr=='2'">
							<a-textarea :rows="2" placeholder="请输入代理政策" style="width: 100%;" v-decorator="['agencyPolicy']" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="供货周期" v-if="ifFacOrBr=='2'">
							<a-textarea :rows="2" placeholder="请输入供货周期" style="width: 100%;" v-decorator="['leadTime']" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row v-if="ifFacOrBr=='2'">
					<a-col :span="8" :offset="4" style="margin-bottom: 16px;">
						<a-button type="primary" @click="totalAddCustom">+ 添加</a-button>
					</a-col>
				</a-row>
				<a-row v-for="(mod, mIdx) in customModules" :key="mIdx" v-if="ifFacOrBr=='2'">
					<a-col :span="4">
						<a-input v-model="mod.key" placeholder="" style="width: 80%; display: inline-block;" />
						<a-icon type="close-circle" style="font-size: 18px; color: #f5222d; cursor: pointer; vertical-align: middle; margin-left: 4px;" @click="delCustomModule(mIdx)" />
					</a-col>
					<a-col :span="8">
						<a-textarea :rows="2" v-model="mod.value" placeholder="请输入编辑内容" style="width: 100%;" />
					</a-col>
				</a-row>
				<div v-if="ifFacOrBr=='2'" style="margin:12px 0;font-size:16px;font-weight:bold;background-color:#4182FF1A;height:40px;line-height:40px;padding-left:40px;">原料溯源</div>
				<a-row v-if="ifFacOrBr=='2'">
					<a-col :span="24">
							<a-form-item label="溯源信息">
								<div style="display:flex;gap:12px;margin-bottom:12px;width:100%">
									<a-input v-model="sourceTracingKey" placeholder="请输入原料名称" style="flex:1" />
									<a-input v-model="sourceTracingValue" placeholder="请输入供应商" style="flex:1" />
									<a-button type="primary" @click="addSourceTracing"> 添加</a-button>
								</div>
								<div ref="dragSourceTracing" style="width:100%;">
									<div class="size_item" v-for="(item, idx) of sourceTracingList" :key="item._key || idx">
										<span class="trace-key">{{ item.key }}</span>
										<span class="trace-value">{{ item.value }}</span>
										<a-icon class="right" type="delete" style="color:red;cursor:pointer" @click="delSourceTracing(idx)" />
									</div>
								</div>
							</a-form-item>
						</a-col>
					</a-row>


				<div style="margin:12px 0;font-size:16px;font-weight:bold;background-color:#4182FF1A;height:40px;line-height:40px;padding-left:40px;">产品详情</div>
				<a-row>
					<a-col :span="24">
						<a-form-item label="详情图片">
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.commentImagesList && editModel.commentImagesList.length > 0">
									<div class="er_content" ref="dragDetailImages">
											<div class="image-wrapper"
												v-for="(img,index) in editModel.commentImagesList" :key="img"
												style="position: relative;display: inline-block;margin: 5px;cursor: grab;">
												<viewer :images="editModel.commentImagesList">
												<img class="er_content_img" :src="img" style="display: block;width:80px;height:80px;object-fit:cover;">
												</viewer>
												<a-icon type="close-circle" style="position: absolute; top: -8px; right: -8px; font-size: 18px; color: #f5222d; cursor: pointer; z-index: 10;" @click="handleDeleteDetailImg(index)" />
											</div>
										</div>
								</div>
								<div class="again_upload_box ml12" v-if="(editModel.commentImagesList || []).length < 50">
									<a-spin :spinning="uploadDetailImageLoading" size="small">
									<input type="file" accept="image/*" multiple @change="uploadDetailImage" :disabled="uploadDetailImageLoading" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">上传详情图片</div>
									</a-spin>
								</div>
							</div>
							<div>只能上传jpg/png格式文件，文件不能超过3M，不能超过50张</div>

						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-item label="自定义详情" :wrapper-col="{ span: 16 }">
						<div ref="wangEditor" style="width: 100%;"></div>
					</a-form-item>
					</a-col>
				</a-row>
			</a-form>
			<a-button @click="mnTj" style="margin: 12px auto; display: block;" type="primary">保存</a-button>
		</div>
	</div>
</template>

<script>
	import Sortable from 'sortablejs'
import E from 'wangeditor'
	import { ossUpload } from "../../../utils/oss";
	import {
		saveFactoryProductApi,
		factoryBusinessApi,
		getFactoryProductDetailApi,
		getTagCategoriesApi,
		getBusinessEntitiesApi
	} from "../../../api/index";

	import FactoryImageUpload from '../JY/FactoryImageUpload.vue'
	import FactoryVideoUpload from '../JY/FactoryVideoUpload.vue'
	import FactoryVRUpload from '../JY/FactoryVRUpload.vue'

	export default {
		components: {
			FactoryImageUpload,
			FactoryVideoUpload,
			FactoryVRUpload
		},
		name: "BaseInfoTab",
		props: {
			ifFacOrBr: {
				type: String,
				default: ""
			},
			initialData: Object,
				brandList: {
				type: Array,
				default: () => []
			},
			formData: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			return {
				allTags: [],


				uploadThumbnailLoading: false,
				uploadMainImageLoading: false,
				uploadVideoCoverLoading: false,
				uploadVideoFileLoading: false,
				uploadDetailImageLoading: false,
				factoryImages: [],
				factoryVideos: [],
				factoryVR: {
					url: '',
					enabled: false
				},
				bigModules: [],
				form: this.$form.createForm(this),
				baseInfo: {},
				originBaseInfo: {},
				plList: [],
				gyList: [],
				zyList: [],
				list: [
					{ tagId: 1, tagName: "001" },
					{ tagId: 2, tagName: "002" },
					{ tagId: 3, tagName: "003" }
				],
				patentList: [],
				rawMaterialList: [],
				processList: [],
				partnershipList: [],
				patentText: '',
				rawText: '',
				processText: '',
				partnerText: '',
				tagInput: '',
				tagListItems: [],
				builtInUnits: ['吨', '千克', '克', '斤', '个', '包', '箱', '袋', '罐', '盒'],
				customUnits: [],
				unitInput: '',
				factoryList: [],
				customModules: [],
					sourceTracingList: [],
					sourceTracingList: [],
					sourceTracingKey: '',
					sourceTracingValue: '',
				factoryProductId: 0,
				editModel: {
					businessType: '',
					productName: '',
					sku: '',
					urlName: '',
					url: '',
					productThumbnail: '',
					minPrice: '',
					maxPrice: '',
					productUnit: '',
					priceChannel: '',
					productImagesList: [],
					videoImage: '',
					videoUrl: '',
					commentImagesList: [],
					customContent: ''
				},
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'],
							['clean']
						],
					},
					placeholder: "请输入自定义产品详情",
					theme: 'snow'
				},
			};
		},
		computed: {
			allUnits() {
				return [...this.builtInUnits, ...this.customUnits];
			}
		},
		watch: {
			formData: {
				deep: true,
				immediate: true,
				handler(val) {
					if (val && Object.keys(val).length > 0) {
						this.initFormData(val);
					} else {
						this.resetEditModel();
					}
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.initEditor()
			})
			this.initAllDrag()
			this.getFactoryData()
		},
		updated() {
			this.$nextTick(() => {
				// v-show 切换时重新初始化编辑器
				const el = this.$refs.wangEditor;
				if (el && !this.editor) {
					this.initEditor();
				}
			})
		},
		updated() {
			this.$nextTick(() => {
				if (this.$refs.dragMainImages) {
					this.createDrag('dragMainImages', this.editModel.productImagesList, { filter: '.again_upload_box', forceFallback: true })
				}
				if (this.$refs.dragDetailImages) {
					this.createDrag('dragDetailImages', this.editModel.commentImagesList, { filter: '.again_upload_box', forceFallback: true })
				}
				})
		},
		created() {
			this.baseInfo = JSON.parse(JSON.stringify(this.initialData || {}));
			this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
			getTagCategoriesApi({                    tagTypeCategory: this.ifFacOrBr == '1' ? 'FACTORY' : 'BRAND'}).then(res => {
				if (res.resultStatus) {
					const cat = (res.resultData || []).find(c => c.tagCategoryId === 1 || c.tagCategoryId === 7);
					this.allTags = cat ? cat.tags : [];
				}
			}).catch(err => console.error(err));
		},
		methods: {
			// 重置表单
			resetEditModel() {
				this.editModel = {
					businessType: '',
					productName: '',
					sku: '',
					urlName: '',
					url: '',
					productThumbnail: '',
					minPrice: '',
					maxPrice: '',
					productUnit: '',
					priceChannel: '',
					productImagesList: [],
					videoImage: '',
					videoUrl: '',
					commentImagesList: [],
					customContent: ''
				}
				this.tagListItems = [];
				this.customModules = [];
				this.sourceTracingList = [];
				this.sourceTracingKey = '';
				this.sourceTracingValue = '';
				this.tagInput = '';
				this.unitInput = '';
				// 重置编辑器内容
				this.$nextTick(() => {
					if (this.editor) {
						this.editor.txt.html('');
					}
				});
				try {
					this.form.resetFields();
				} catch(e) {}
			},
			// 真实提交产品接口，全部读取editModel表单数据
			async mnTj() {
				this.form.setFieldsValue({
					productThumbnail: this.editModel.productThumbnail || '',
					tagId: this.editModel.tagId || '',
					productImages: (this.editModel.productImagesList && this.editModel.productImagesList.length > 0) ? '1' : '',
					tagList: (this.tagListItems && this.tagListItems.length > 0) ? '1' : ''
				});
				try {
					await new Promise((resolve, reject) => {
						this.form.validateFields((err) => {
							if (err) { reject(err); } else { resolve(); }
						});
					});
				} catch {
					return;
				}
				// 从表单读取 decorator 管理的值
				const formVals = this.form.getFieldsValue(['businessType', 'productName', 'sku', 'keyCapabilities', 'stages', 'productAb', 'taste', 'productionLicense', 'signatureIngredients', 'leadTime', 'agencyPolicy', 'factoryId']);
				this.editModel.businessType = formVals.businessType;
				this.editModel.productName = formVals.productName;
				const factoryProductId = this.formData?.factoryProductId || 0;
				// 数组转逗号分隔字符串
				const productImagesStr = Array.isArray(this.editModel.productImagesList)
					? this.editModel.productImagesList.filter(Boolean).join(',')
					: '';
				const detailImgStr = Array.isArray(this.editModel.commentImagesList)
					? this.editModel.commentImagesList.filter(Boolean).join(',')
					: '';

				const submitParams = {
					factoryLangId: this.initialData.businessLangId,
					factoryProductId: factoryProductId,
					productName: this.editModel.productName || '',
					productCategroy: this.editModel.businessType || '',
					urlName: this.editModel.urlName || '',
					url: this.editModel.url || '',
					productThumbnail: this.editModel.productThumbnail || '',
					minPrice: Number(this.form.getFieldValue('minPrice')) || 0,
					maxPrice: Number(this.form.getFieldValue('maxPrice')) || 0,
					productUnit: this.form.getFieldValue('productUnit') || '',
					sku: this.form.getFieldValue('sku') || '',
					priceChannel: this.editModel.priceChannel || '',
					tagId: this.editModel.tagId || '',
					productImages: productImagesStr,
					videoImage: this.editModel.videoImage || '',
					videoUrl: this.editModel.videoUrl || '',
					productDetailImage: detailImgStr,
					productDetail: this.editModel.customContent || '',
					keyCapabilities: formVals.keyCapabilities || '',
					stages: formVals.stages || null,
					productAb: formVals.productAb || '',
					taste: formVals.taste || '',
					productionLicense: formVals.productionLicense || '',
					signatureIngredients: formVals.signatureIngredients || '',
					leadTime: formVals.leadTime || '',
					agencyPolicy: formVals.agencyPolicy || '',
					factoryId: formVals.factoryId || '',
					custom: JSON.stringify(this.customModules),
					sourceTracing: JSON.stringify(this.sourceTracingList.map(i => ({ key: i.key, value: i.value })))
				};

				const indexTagsStr = this.tagListItems.filter(Boolean).join(';');
				if (indexTagsStr) submitParams.indexTags = indexTagsStr;

				try {
					const res = await saveFactoryProductApi(submitParams);
					if (res.resultStatus) {
						this.$message.success(factoryProductId ? "编辑产品成功" : "新增产品成功");
						this.$emit('back');
					} else {
						this.$message.error(res.errorMessage || "提交失败");
					}
				} catch (err) {
					console.error('产品提交异常', err);
					this.$message.error("接口请求异常，请重试");
				}
			},
			handleBack() {
				this.$emit('back')
			},
			initFormData(data) {
				if (!data) return;
				this.baseInfo = JSON.parse(JSON.stringify(data || {}));
				if (this.baseInfo.factoryProductId) {
					this.factoryProductId = this.baseInfo.factoryProductId
				}
				this.getDetail(this.factoryProductId)
			},
			handleFormChange() {
				const isModified = JSON.stringify(this.baseInfo) !== JSON.stringify(this.originBaseInfo);
				this.$emit("dirty", isModified);
			},
			initEditor() {
				if (!this.$refs.wangEditor) return;
				this.editor = new E(this.$refs.wangEditor);
				this.editor.config.height = 300;
				this.editor.config.customUploadImg = (files, insert) => {
					files.forEach(file => {
						if (file.size > 3 * 1024 * 1024) { this.$message.error(file.name + ' 超过3MB限制'); return; }
						ossUpload(file, '', 'image/').then(res => {
							insert(res.url);
						}).catch(() => {
							this.$message.error('图片上传失败');
						});
					});
				};
				this.editor.config.onchange = (html) => {
					this.editModel.customContent = html;
				};
				this.editor.create();
				if (this.editModel.customContent) {
					this.editor.txt.html(this.editModel.customContent);
				}
			},
			initAllDrag() {
				this.createDrag('dragContainerPL', this.plList, { handle: '.size_item', draggable: '.size_item' })
				this.createDrag('dragContainerGY', this.gyList, { handle: '.size_item', draggable: '.size_item' })
				this.createDrag('dragPatent', this.patentList, { handle: '.size_item', draggable: '.size_item' })
					this.createDrag('dragTagList', this.tagListItems)
					this.createDrag('dragSourceTracing', this.sourceTracingList)

			},
			createDrag(refName, list, options) {
				const el = this.$refs[refName]
				if (!el) return
				// 销毁已有实例
				if (el._sortableInstance) {
					el._sortableInstance.destroy()
				}
				el._sortableInstance = Sortable.create(el, {
					animation: 150,
					ghostClass: 'sort-ghost',
					...options,
					onEnd: (evt) => {
						const { oldIndex, newIndex } = evt
						const moveItem = list.splice(oldIndex, 1)[0]
						list.splice(newIndex, 0, moveItem)
					}
				})
			},
			onChange(value, selectedOptions) {
				this.baseInfo.province = selectedOptions[0].text
				this.baseInfo.provinceCode = selectedOptions[0].value
				this.baseInfo.city = selectedOptions[1].text
				this.baseInfo.cityCode = selectedOptions[2].value
			},
			filterOption(input, option) {
				return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
			},
			addziyou() {
				const val = this.baseInfo.plText;
				if (!val) return this.$message.warning('请选择');
				const exist = this.plList.some(i => i.businessId == val);
				if (exist) return this.$message.warning('已添加');
				const item = this.brandList.find(i => i.businessId == val);
				if (item) this.plList.push(item);
			},
			deletePL(idx) {
				this.plList.splice(idx, 1);
			},
			addHZ() {
				const val = this.baseInfo.gyText;
				if (!val) return this.$message.warning('请选择');
				const exist = this.gyList.some(i => i.businessId == val);
				if (exist) return this.$message.warning('已添加');
				const item = this.brandList.find(i => i.businessId == val);
				if (item) this.gyList.push(item);
			},
			deleteGY(idx) {
				this.gyList.splice(idx, 1);
			},
			addZY() {
				const val = this.baseInfo.zyText;
				if (!val) return this.$message.warning('请选择');
				const exist = this.zyList.some(i => i.tagId == val);
				if (exist) return this.$message.warning('已添加');
			},
			deleteZY(idx) {
				this.zyList.splice(idx, 1);
			},
			addPatent() {
				if (!this.patentText) return;
				this.patentList.push(this.patentText);
				this.patentText = '';
			},
			delPatent(idx) {
				this.patentList.splice(idx, 1);
			},
			addRaw() {
				if (!this.rawText) return;
				this.rawMaterialList.push(this.rawText);
				this.rawText = '';
			},
			delRaw(idx) {
				this.rawMaterialList.splice(idx, 1);
			},
			addProcess() {
				if (!this.processText) return;
				this.processList.push(this.processText);
				this.processText = '';
			},
			delProcess(idx) {
				this.processList.splice(idx, 1);
			},
			addPartner() {
				if (!this.partnerText) return;
				this.partnershipList.push(this.partnerText);
				this.partnerText = '';
			},
			delPartner(idx) {
				this.partnershipList.splice(idx, 1);
			},
			// ======================
			// 列表标签
			// ======================
			addTag() {
				if (!this.tagInput) return;
				if (this.tagListItems.length >= 3) {
					this.$message.warning('最多3个标签');
					return;
				}
				this.tagListItems.push(this.tagInput);
				this.tagInput = '';
			},
			delTag(idx) {
				this.tagListItems.splice(idx, 1);
			},
			handleSubmit() {
				this.form.validateFields(async (err, values) => {
					if (!err) {
						await this.saveData(values);
						this.$message.success('保存成功');
					}
				});
			},
			getBigModulesSubmitStr() {
				const result = this.bigModules.map(item => {
					return {
						key: item.key || '',
						value: Array.isArray(item.value) ? item.value.join(';') : item.value
					};
				});
				return JSON.stringify(result);
			},
			async saveData(values) {
				const originalList = this.factoryImages;
				const originalListVideo = this.factoryVideos;
				let hasError = false;
				for (let i = 0; i < originalList.length; i++) {
					const item = originalList[i];
					const brandLine = (item.brandLine || '').trim();
					const factoryImages = (item.factoryImages || '').trim();
					if (!brandLine && !factoryImages) continue;
					if (brandLine && !factoryImages) {
						this.$message.warning(`第 ${i+1} 个分布：你还没有上传图片`);
						hasError = true;
						break;
					}
					if (!brandLine && factoryImages) {
						this.$message.warning(`第 ${i+1} 个分布：你还没有填写分布名称`);
						hasError = true;
						break;
					}
				}
				if (hasError) return;
				const factoryEnvironmentImages = originalList.map(item => {
					return {
						brandLine: item.brandLine,
						factoryImages: item.factoryImages
					};
				});
				const factoryEnvironmentVideos = originalListVideo.map(item => {
					return {
						brandLine: item.brandLine,
						factoryImages: item.factoryImages,
						factoryVideo: item.factoryVideo
					};
				});
				let params = {
					"businessLangId": this.initialData.businessLangId,
					"businessScale": values.businessScale,
					"cooperationModel": values.cooperationModel,
					"cooperationOrderNum": values.cooperationOrderNum,
					"brandIds": this.plList.map(i => i.businessId).join(','),
					"cooperationBrandIds": this.gyList.map(i => i.businessId).join(','),
					"serviceProvider": this.patentList.join(';'),
					"annualCapacity": values.annualCapacity,
					"annualCapacityYear": values.annualCapacityYear,
					"annualOutputValue": values.annualOutputValue,
					"annualOutputValueYear": values.annualOutputValueYear,
					"businessDesc": values.businessDesc,
					"businessCoreAdvantage": values.businessCoreAdvantage,
					"otherFactorDesc": JSON.stringify(this.bigModules),
					"factoryEnvironmentImages": factoryEnvironmentImages,
					"factoryEnvironmentVideos": factoryEnvironmentVideos
				}
				return factoryBusinessApi(params).then(res => {
					this.$emit('dirty', false);
				});
			},
			filterOption(input, option) {
				return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
			},
			// ======================
			// 溯源信息
			// ======================
			addSourceTracing() {
				if (!this.sourceTracingKey && !this.sourceTracingValue) {
					this.$message.warning('请输入原料名称或者供应商');
					return;
				}
				this.sourceTracingList.push({
					key: this.sourceTracingKey,
					value: this.sourceTracingValue,
					_key: Date.now() + '_' + Math.random()
				});
				this.sourceTracingKey = '';
				this.sourceTracingValue = '';
			},
			delSourceTracing(idx) {
				this.sourceTracingList.splice(idx, 1);
			},
			// ======================
			// 自定义编辑项目
			// ======================
			totalAddCustom() {
				for (var i = 0; i < this.customModules.length; i++) {
					var m = this.customModules[i];
					if (!m.key && !m.value) {
						this.$message.warning('请先填写已有项目的内容');
						return;
					}
				}
				this.customModules.push({ key: '', value: '' });
			},
			delCustomModule(mIdx) {
				this.customModules.splice(mIdx, 1);
			},
			// ======================
			// 获取工厂列表（生产厂家）
			// ======================
			getFactoryData() {
				getBusinessEntitiesApi({
					pageNo: 1,
					pageSize: 1000,
					businessType: 'FACTORY'
				}).then((res) => {
					if (res.resultStatus) {
						this.factoryList = res.resultData.dataList || [];
					} else {
						this.factoryList = [];
					}
				}).catch((err) => {
					console.error(err);
				}).finally(() => {
				});
			},
			getDetail(val) {
				getFactoryProductDetailApi({
					"factoryProductId": val
				})
				.then((res) => {
					if (res.resultStatus) {
						const data = res.resultData;
						this.editModel = {
							businessType: data.productCategroy || '',
							productName: data.productName || '',
							sku: data.sku || '',
							urlName: data.urlName || '',
							url: data.url || '',
							productThumbnail: data.productThumbnail || '',
							minPrice: data.minPrice ?? '',
							maxPrice: data.maxPrice ?? '',
							productUnit: data.productUnit || '',
								priceChannel: data.priceChannel || '',
							videoImage: data.videoImage || '',
							videoUrl: data.videoUrl || '',
							customContent: data.productDetail || '',
							tagId: data.tagId || '',
										productImagesList: data.productImages ? data.productImages.split(',').filter(Boolean) : [],
							commentImagesList: data.productDetailImage ? data.productDetailImage.split(',').filter(Boolean) : []
						}
						this.tagListItems = data.indexTags ? data.indexTags.split(';').filter(Boolean) : [];
						this.customModules = data.custom ? JSON.parse(data.custom) : [];
						this.sourceTracingList = data.sourceTracing ? JSON.parse(data.sourceTracing) : [];
						this.$nextTick(() => {
							this.form.setFieldsValue({
								businessType: data.productCategroy || '',
								productName: data.productName || '',
								keyCapabilities: data.keyCapabilities || '',
								stages: data.stages || null,
								productAb: data.productAb || '',
								taste: data.taste || '',
								productionLicense: data.productionLicense || '',
								signatureIngredients: data.signatureIngredients || '',
								leadTime: data.leadTime || '',
								agencyPolicy: data.agencyPolicy || '',
								factoryId: data.factoryId || '',
								minPrice: data.minPrice ?? '',
								maxPrice: data.maxPrice ?? '',
								sku: data.sku || '',
								productUnit: data.productUnit || ''
							});
							this.$nextTick(() => {
								if (this.editor) {
									this.editor.txt.html(data.productDetail || '');
								}
							});
						});
					} else {
						console.log("res", res);
					}
				})
				.catch((error) => {
					console.log(error);
				})
			},
			// 上传缩略图
			uploadThumbnail(e) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
				if (file.size > 3 * 1024 * 1024) { this.$message.error('图片不能超过3MB'); return; }
				this.uploadThumbnailLoading = true;
				ossUpload(file, '', 'image/').then(res => {
					this.editModel.productThumbnail = res.url;
					this.$message.success('缩略图上传成功');
				}).catch(() => {
					this.$message.error('缩略图上传失败');
				}).finally(() => {
					this.uploadThumbnailLoading = false;
				})
				e.target.value = '';
			},
			// 上传产品主图（多图追加，最多10张）
			uploadMainImage(e) {
				const files = e.target.files || [];
				if (!files.length) return;
				const currentCount = (this.editModel.productImagesList || []).length;
				const maxCanAdd = 10 - currentCount;
				if (files.length > maxCanAdd) {
					this.$message.warning('只能再选 ' + maxCanAdd + ' 张，已自动截取前 ' + maxCanAdd + ' 张');
				}
				const toUpload = Array.from(files).slice(0, maxCanAdd);
				for (const f of toUpload) {
					if (f.size > 3 * 1024 * 1024) { this.$message.error(f.name + ' 超过3MB限制'); return; }
				}
				this.uploadMainImageLoading = true;
				const uploads = toUpload.map(f => ossUpload(f, '', 'image/'));
				Promise.all(uploads).then(results => {
					if (!this.editModel.productImagesList) this.editModel.productImagesList = [];
					results.forEach(r => { this.editModel.productImagesList.push(r.url); });
					this.$message.success('主图上传成功');
				}).catch(() => {
					this.$message.error('主图上传失败');
				}).finally(() => {
					this.uploadMainImageLoading = false;
				})
				e.target.value = '';
			},
			// 删除主图
			handleDeleteMainImg(index) {
				this.editModel.productImagesList.splice(index, 1);
			},
			// 上传视频封面
			uploadVideoCover(e) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
					if (file.size > 3 * 1024 * 1024) { this.$message.error('图片不能超过3MB'); return; }
				this.uploadVideoCoverLoading = true;
				ossUpload(file, '', 'image/').then(res => {
					this.editModel.videoImage = res.url;
					this.$message.success('封面上传成功');
				}).catch(() => {
					this.$message.error('封面上传失败');
				}).finally(() => {
					this.uploadVideoCoverLoading = false;
				})
				e.target.value = '';
			},
			// 上传视频文件
			uploadVideoFile(e) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
					if (file.size > 10 * 1024 * 1024) { this.$message.error('视频不能超过10MB'); return; }
				this.uploadVideoFileLoading = true;
				ossUpload(file, '', 'video/').then(res => {
					this.editModel.videoUrl = res.url;
					this.$message.success('视频上传成功');
				}).catch(() => {
					this.$message.error('视频上传失败');
				}).finally(() => {
					this.uploadVideoFileLoading = false;
				})
				e.target.value = '';
			},
			// 上传详情图片（多图追加，最多50张）
			uploadDetailImage(e) {
				const files = e.target.files || [];
				if (!files.length) return;
				const currentCount = (this.editModel.commentImagesList || []).length;
				const maxCanAdd = 50 - currentCount;
				if (files.length > maxCanAdd) {
					this.$message.warning('只能再选 ' + maxCanAdd + ' 张，已自动截取前 ' + maxCanAdd + ' 张');
				}
				const toUpload = Array.from(files).slice(0, maxCanAdd);
				for (const f of toUpload) {
					if (f.size > 3 * 1024 * 1024) { this.$message.error(f.name + ' 超过3MB限制'); return; }
				}
				this.uploadDetailImageLoading = true;
				const uploads = toUpload.map(f => ossUpload(f, '', 'image/'));
				Promise.all(uploads).then(results => {
					if (!this.editModel.commentImagesList) this.editModel.commentImagesList = [];
					results.forEach(r => { this.editModel.commentImagesList.push(r.url); });
					this.$message.success('详情图上传成功');
				}).catch(() => {
					this.$message.error('详情图上传失败');
				}).finally(() => {
					this.uploadDetailImageLoading = false;
				})
				e.target.value = '';
			},
			// 删除详情图片
			handleDeleteDetailImg(index) {
				this.editModel.commentImagesList.splice(index, 1);
			},
			totalAddBJ() {
				this.bigModules.push({
					key: '',
					value: '',
				})
			},
		},
	};
</script>

<style scoped lang="less">
	.product-tab {
		padding: 16px 16px 16px 0;
	}
	.tabTitle {
		width: 100%;
		height: 40px;
		background-color: #4182FF1A;
		font-size: 16px;
		color: #333;
		line-height: 38px;
		padding-left: 40px;
		font-weight: bold;
	}
	.mt12 {
		margin-top: 12px;
	}
	.mr12 {
		margin-right: 12px;
	}
	.sort-ghost {
		opacity: 0.5;
		background: #f5f5f5;
	}
	.size_item {
		height: 50px;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		cursor: move;
		padding: 0 10px;
		gap: 8px;
		.trace-key {
			background: #fff;
			padding: 2px 10px;
			border-radius: 4px;
			flex: 1;
		}
		.trace-value {
			background: #fff;
			padding: 2px 10px;
			border-radius: 4px;
			flex: 1;
		}
		.left {
			flex: 1;
			padding-left: 10px;
		}
		.right {
			width: 50px;
			text-align: center;
		}
		.left {
			flex: 1;
			padding-left: 10px;
		}
		.right {
			width: 50px;
			text-align: center;
		}
	}
</style>

<style>
/* viewer 图片放大遮罩层被 wangEditor 遮挡 */
.viewer-container {
    z-index: 99999 !important;
}
.viewer-backdrop {
    z-index: 99998 !important;
}
.viewer-footer {
    z-index: 99999 !important;
}
.viewer-toolbar {
    z-index: 99999 !important;
}
.viewer-navbar {
    z-index: 99999 !important;
}
.viewer-button {
    z-index: 99999 !important;
}
.viewer-canvas {
    z-index: 99998 !important;
}
.w-e-text-container {
    z-index: 1 !important;
}
.w-e-toolbar {
    z-index: 99999 !important;
}
</style>
